import Vue from 'vue'
import router from './router'
import History from './router/history'

function popstateHandle() {
  // console.log('监听了返回键')
  router.isBack = true
  let el = document.getElementById('app')
  if (el) el.setAttribute('transition-direction', 'back')
}

// window.sessionStorage.setItem('isCached', 'true')

function hasCached(key) {
  return new Promise(resolve => {
    const isCached =localStorage.getItem(key) !== null
    resolve(isCached)
  })
}

router.beforeEach((to, from, next) => {
  console.log('to', to)
  const whiteList = ['/test','/recive','/goods']
  // const hasDefaultRoute = to.matched.some(route => route.meta.defaultRoute)
  hasCached('token_yr').then(bol => {
    if (bol) {
      if (to.path === '/test') {
        next({ path: '/' })
      } else {
        next()
      }
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        next()
      } 
      else {
        next('/test')
      }
    }
  })

  // 路由跳转动画
  if (to.meta.disAnimation) {
    Vue.prototype.$transition = null
  } else {
    Vue.prototype.$transition = 'fade-effect'
  }

  // 路由历史
  if (router.isBack) {
    History.pop()
    router.isBack = false
  } else {
    History.push(to.path)
  }

  // 返回键监听
  window.addEventListener('popstate', popstateHandle, false)
})
